module.exports = __webpack_public_path__ + "a71497ada34fc06ff0d694c43d4ea949.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/url-loader?limit=1!./src/assets/fonts/digital.ttf
// module id = 571
// module chunks = 1